"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSchemaProps = createSchemaProps;
exports.formatAuthor = formatAuthor;
exports.getComponentContentNodeContent = getComponentContentNodeContent;
exports.getRelatedArticles = getRelatedArticles;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
/* eslint-disable import/no-extraneous-dependencies */

function formatAuthor(author) {
  if ((0, _isEmpty2["default"])(author)) {
    return '';
  }
  var firstName = author.firstName,
    lastName = author.lastName,
    email = author.email;
  if (firstName && lastName) {
    return "".concat(firstName, " ").concat(lastName);
  }
  if (email) {
    return email;
  }
  return '';
}
function createSchemaProps(blogPost, businessName, businessCategories, businessLogo) {
  var _ref = blogPost || {},
    title = _ref.title,
    publishedAt = _ref.publishedAt,
    heroImage = _ref.heroImage,
    author = _ref.author,
    content = _ref.content,
    summary = _ref.summary;
  return {
    businessName: businessName,
    businessCategories: businessCategories,
    businessLogo: businessLogo,
    title: title,
    content: content,
    summary: summary,
    datePublished: publishedAt,
    author: formatAuthor(author),
    heroImage: heroImage
  };
}
function getRelatedArticles(articles, blogId, destination) {
  var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    _ref2$max = _ref2.max,
    max = _ref2$max === void 0 ? 5 : _ref2$max;
  return articles.filter(function (_ref3) {
    var currentId = _ref3._id,
      currentDestination = _ref3.destination;
    return currentId !== blogId && currentDestination === destination;
  }).slice(0, max);
}
function getComponentContentNodeContent(_ref4) {
  var components = _ref4.components,
    componentName = _ref4.componentName,
    componentId = _ref4.componentId,
    _ref4$defaultValue = _ref4.defaultValue,
    defaultValue = _ref4$defaultValue === void 0 ? '' : _ref4$defaultValue,
    _ref4$selectFirst = _ref4.selectFirst,
    selectFirst = _ref4$selectFirst === void 0 ? true : _ref4$selectFirst;
  if ((0, _isEmpty2["default"])(components || (0, _isEmpty2["default"])(componentId))) {
    return defaultValue;
  }
  var foundComponents = components.filter(function (_ref5) {
    var fastId = _ref5.fastId,
      componentIdentifier = _ref5.componentIdentifier;
    if ((0, _isEmpty2["default"])(componentName)) {
      return componentIdentifier === componentId;
    }
    return fastId === componentName && componentIdentifier === componentId;
  });
  if ((0, _isEmpty2["default"])(foundComponents)) {
    return defaultValue;
  }
  if (!selectFirst && foundComponents.length > 1) {
    return defaultValue;
  }
  var foundComponent = foundComponents[0];
  var _ref6 = foundComponent || {},
    _ref6$contentNodes = _ref6.contentNodes,
    contentNodes = _ref6$contentNodes === void 0 ? [] : _ref6$contentNodes;
  if ((0, _isEmpty2["default"])(contentNodes)) {
    return defaultValue;
  }
  if (!selectFirst && contentNodes.length > 1) {
    return defaultValue;
  }
  var contentNode = contentNodes[0];
  var _ref7 = contentNode || {},
    _ref7$content = _ref7.content,
    content = _ref7$content === void 0 ? '' : _ref7$content;
  return content || '';
}